import React, { FC, Suspense, useState, lazy, useTransition } from 'react'
import { StyledWrapper } from './style';
import ProfilePageMenu from '../Menu';
import Container from '@/Components/atoms/Container';
import { ProfilePageModules } from '../..';
import Loader from '@/Components/atoms/Loader';
import { colors } from '@/styles/colors';
import { useIsTablet } from '@/Hooks/useIsTablet';
import { useTranslation } from 'next-i18next';

const WalletModule = lazy(() => import('../../Modules/Wallet'));
const ArchivedChatsModule = lazy(() => import('../../Modules/ArchivedChats'));
const MyPostsModule = lazy(() => import('../../Modules/My_posts'));
const NotificationsModule = lazy(() => import('../../Modules/Notifications'));
const UserSettingsModule = lazy(() => import('../../Modules/User_settings'));
const PrivacyModule = lazy(() => import('../../Modules/Privacy'));
const ServiceModule = lazy(() => import('../../Modules/Service'));
const LanguageModule = lazy(() => import('../../Modules/Language'));

interface IMainProps {
  moduleName: ProfilePageModules;
};

const Main: FC<IMainProps> = ({ moduleName }) => {
  const { t } = useTranslation(['common']);
  const [isPending, startTransition] = useTransition();
  const [activeModule, setActiveModule] = useState<ProfilePageModules>(moduleName);
  const [menuVisible, setMenuVisible] = useState<boolean>(moduleName === ProfilePageModules.default);
  const isTablet = useIsTablet();
  let selectedModule: ProfilePageModules = activeModule === ProfilePageModules.default ? ProfilePageModules.wallet : activeModule;
  
  if(isTablet && menuVisible) {
    selectedModule = ProfilePageModules.default;
  }

  const onSelectModule = (name: ProfilePageModules) => {
    startTransition(() => {
      setActiveModule(name);
      setMenuVisible(false);
    });
    window.scrollTo(0, 0);
  };

  const backToMenu = () => {
    setMenuVisible(true);
  }

  let Module;
  switch (activeModule) {
    case ProfilePageModules.wallet: {
      Module = <WalletModule handleBackToMenu={backToMenu}/>;
      break;
    }
    case ProfilePageModules.archived_chats: {
      Module = <ArchivedChatsModule handleBackToMenu={backToMenu}/>;
      break;
    }
    case ProfilePageModules.my_posts: {
      Module = <MyPostsModule handleBackToMenu={backToMenu}/>;
      break;
    }
    case ProfilePageModules.notifications: {
      Module = <NotificationsModule handleBackToMenu={backToMenu}/>;
      break;
    }
    case ProfilePageModules.user_settings: {
      Module = <UserSettingsModule handleBackToMenu={backToMenu}/>;
      break;
    }
    case ProfilePageModules.privacy: {
      Module = <PrivacyModule handleBackToMenu={backToMenu}/>;
      break;
    }
    case ProfilePageModules.service: {
      Module = <ServiceModule handleBackToMenu={backToMenu}/>;
      break;
    }
    case ProfilePageModules.language: {
      Module = <LanguageModule handleBackToMenu={backToMenu}/>;
      break;
    }
    case ProfilePageModules.default: {
      Module = <WalletModule handleBackToMenu={backToMenu}/>;
      break;
    }
    default: {
      Module = <WalletModule handleBackToMenu={backToMenu}/>;
      break;
    }
  }

  


  const LOADER = <Loader key='121212' color={colors.primary} type='blockCentered' size={50} />;

  
  return (
    <StyledWrapper className='profile-page' menu={menuVisible}>
      <Container className='profile-page__container'>
        <div className='profile-page__sidebar'>
          <ProfilePageMenu onSelect={onSelectModule} activeModule={selectedModule} />
        </div>
        <div className='profile-page__content'>
          
        <Suspense fallback={LOADER}>
          { isPending ? LOADER : Module }
        </Suspense>
        </div>
      </Container>
    </StyledWrapper>
  )
}

export default Main;
